<template lang="pug">
  .chat
    vm-row.top(vm-w="12")
      vm-col(vm-w="6")
        span {{ $t('rfis.new_rfi') }}
      vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w="6")
        vm-button(icon="close" type="flat" size="small" text-color="white" color="#565656" @click="setChatVisible(false)")
    vm-row.center(vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-typeahead(autofocus url="projects" :label='$t("rfis.project_id")' disable-match :serializer="item => item.project_name" required :data="rfisCatalog.projects" :placeholder='$t("rfis.project_id_placeholder")' v-model="newRecord.project" :filter="query => `?param=${query},project_name`" @input-change="autoCompleteFunc")
            template(slot-scope="{data}")
              vm-typeahead-item(is="vm-typeahead-item" v-bind:key="index" v-bind:value="item.data" v-bind:text="item.text" v-for="item,index in data")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("rfis.rfi_number_placeholder")' v-model="newRecord.rfi_number" :label='$t("rfis.rfi_number")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-select(:placeholder='$t("rfis.type_placeholder")' v-model="newRecord.type" :label='$t("rfis.type")')
            vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in types")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("rfis.requested_information_placeholder")' v-model="newRecord.requested_information" :label='$t("rfis.requested_information")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-textarea(:placeholder='$t("rfis.question_placeholder")' v-model="newRecord.question" type="text" :label='$t("rfis.question")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("rfis.reference_placeholder")' v-model="newRecord.reference" :label='$t("rfis.reference")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          input(type="file" multiple name="files[]" @change="handleFileUpload" accept="image/jpeg, image/x-png, application/pdf")
    vm-row.bottom(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w="12")
      vm-button(icon="save-outline" @click="saveRecord" :disabled="!!$v.newRecord.$invalid") {{ $t('strings.save') }}
</template>

<script>
import moment from 'moment'
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Rfis')

export default {
  name: 'Chat',
  data: () => ({
    filename: null,
    newRecord: {
      requested_date: moment().format('YYYY-MM-DD'),
      is_rfi_question: 1
    },
    types: [
      {
        name: 'Quotation',
        id: 1
      },
      {
        name: 'Revision',
        id: 2
      },
      {
        name: 'Other',
        id: 3
      }
    ]
  }),
  validations: {
    newRecord: {
      project: {
        required
      },
      type: {
        required
      },
      requested_information: {
        required
      },
      question: {
        required
      }
    }
  },
  computed: {
    ...mapGetters([
      'rfisCatalog',
      'isChatVisible'
    ])
  },
  beforeRouteLeave (to, from, next) {
    this.cleanRFIS()
    next()
  },
  methods: {
    ...mapActions([
      'loadCatalog',
      'addRfi',
      'cleanRFIS'
    ]),
    setChatVisible (boolean) {
      this.$emit('visible', boolean)
    },
    async saveRecord () {
      await this.addRfi(this.newRecord)
      this.newRecord = {}
      this.$emit('visible', false)
      if (!['rfis'].includes(this.$route.name)) {
        this.cleanRFIS()
      }
    },
    autoCompleteFunc (value, url) {
      this.loadCatalog({ filter: value, url: url })
    },
    async handleFileUpload ({ target }) {
      this.newRecord.files = target.files
    }
  }
}
</script>
<style lang="scss" scoped>
.chat {
    bottom: 0;
    background: #fff;
    border-radius: 10px;
    width: 34rem;
    position: fixed;
    right: 50px;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    z-index: 9999;
    -webkit-box-shadow: 0px 0px 25px 0 rgba(46, 61, 73, 0.11);
    box-shadow: 0px 0px 25px 0 rgba(46, 61, 73, 0.11);
  .top {
    border-radius: 10px 10px 0px 0px;
    background: #565656;
    height: 42px;
    padding: 8px 5px 10px 20px;
    color: white;
    font-size: 18px;
  }
}
.center {
  padding: 10px 20px;
  overflow-y: auto;
  height: calc(75vh - 250px);
}
.bottom {
  border-top: 0.5px #dad7d7 solid;
  padding: 8px 25px;
}
@media screen and (max-height: 768px) {
  .center {
    height: 60vh;
  }
}
</style>
